/*
  Product Downloads — behaviour for snippets/product-downloads.liquid.
  Opens/closes the self-contained downloads modal (same pattern as samples.js).
  Delegated listeners, so it works no matter when the markup enters the DOM
  (section re-render in the editor, quick view, etc.).
  Self-guards: does nothing on pages without a downloads modal.
*/
(function () {
  var openModalEl = null;
  var lastFocused = null;

  function openModal(trigger) {
    var id = trigger.getAttribute('data-downloads-open');
    var modal = id ? document.getElementById(id) : null;
    if (!modal) return;
    closeModal();
    lastFocused = trigger;
    openModalEl = modal;
    modal.hidden = false;
    document.body.classList.add('downloads-modal-open');
    if (typeof trapFocus === 'function') trapFocus(modal);
  }

  function closeModal() {
    var modal = openModalEl || document.querySelector('.downloads-modal:not([hidden])');
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('downloads-modal-open');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(modal);
    else if (lastFocused) lastFocused.focus();
    openModalEl = null;
    lastFocused = null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-downloads-open]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger);
      return;
    }
    if (e.target.closest('[data-downloads-close]')) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
